import { render } from "./laborSeasonPage.vue?vue&type=template&id=3b1edb75&scoped=true"
import script from "./laborSeasonPage.vue?vue&type=script&lang=js"
export * from "./laborSeasonPage.vue?vue&type=script&lang=js"

import "./laborSeasonPage.vue?vue&type=style&index=0&id=3b1edb75&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1edb75"]])

export default __exports__